import api from "./api";
import { getFullDocument } from "./getFullDocument";

export async function deleteDocument(documentId: string) {
  const fullDocument = await getFullDocument(documentId, {
    include_questions: true,
  });

  if (!fullDocument) {
    return;
  }

  const deleteDocument = await api.delete(`/documents/${documentId}`);
  return deleteDocument.data;
}
